import React from 'react';
import { Link } from "react-router-dom"

import Nav from './Nav'


class User extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};

		this.email = React.createRef();
		this.referralExtraInputValue = React.createRef();
		this.referralDisplayName = React.createRef();
	}

	async componentDidMount() {
		try {
			let snapshot = await window.firebase.firestore().collection('users').where('twitterUsername', '==', this.props.match.params.username).get()
			let userData = snapshot.docs[0].data()
			userData.uid = snapshot.docs[0].id
			// console.log(userData);
			this.setState({ userData: userData })

			let followerId = window.localStorage.getItem(this.state.userData.uid + '-followerId')
			this.setState({ followerId: followerId })

			if (followerId) {
				this.setState({
					followerReferralExtraInputValue: window.localStorage.getItem(this.state.userData.uid + '-followerReferralExtraInputValue'),
					followerReferralDisplayName: window.localStorage.getItem(this.state.userData.uid + '-followerReferralDisplayName'),
				})
			}

		} catch (error) {
			console.error(error.message || error);
			this.setState({ userData: null })
		}
	}

	handleSubmit = async (event) => {
		event.preventDefault()

		let query = new URLSearchParams(this.props.location.search);
		// console.log(this.email.current.value, query.get('ref'))

		try {
			this.setState({ error: null })

			if (!this.email.current.value) throw 'Please enter an email'

			let data = {
				uid: this.state.userData.uid,
				twitterUsername: this.state.userData.twitterUsername,
				followerEmail: this.email.current.value,
				createdAt: new Date(),
			}
			if (query.get('ref')) data.referrer = query.get('ref')

			let docRef = await window.firebase.firestore().collection('followers').add(data)
			// console.log(docRef.id);

			this.setState({ followerId: docRef.id })
			window.localStorage.setItem(this.state.userData.uid + '-followerId', docRef.id)

		} catch (e) {
			console.log(e.message || e);
			this.setState({ error: e.message || e })
		}
	}
	handleSubmitReferralExtra = async (event) => {
		event.preventDefault()

		try {
			// if (!this.referralExtraInputValue.current.value) throw 'Please enter a value'

			this.setState({ handleSubmitReferralExtraStatus: '...' })

			await window.firebase.firestore().collection('followers').doc(this.state.followerId).update({
				// referralExtraInputValue: this.referralExtraInputValue.current.value,
				referralDisplayName: this.referralDisplayName.current.value,
			})
			this.setState({
				// followerReferralExtraInputValue: this.referralExtraInputValue.current.value,
				followerReferralDisplayName: this.referralDisplayName.current.value,
				handleSubmitReferralExtraStatus: 'Saved!'
			})
			// window.localStorage.setItem(this.state.userData.uid + '-followerReferralExtraInputValue', this.referralExtraInputValue.current.value)
			window.localStorage.setItem(this.state.userData.uid + '-followerReferralDisplayName', this.referralDisplayName.current.value)

		} catch (e) {
			console.log(e.message || e);
			window.alert(e.message || e)
		}
	}

	referralLink = () => {
		if (!this.state.followerId) return ''
		return '/' + this.state.userData.twitterUsername + '?ref=' + this.state.followerId + '&name=' + this.state.followerReferralDisplayName
	}

	copyToClipboard = str => {
		const el = document.createElement('textarea');
		el.value = str;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};
	copyReferralLink = () => {
		this.copyToClipboard(window.location.host + this.referralLink())
		this.setState({
			copyReferralLinkStatus: 'Copied!'
		})
	}


	render() {
		return (
			<>
				<Nav {...this.props} ></Nav>
				<div className="d-flex align-items-center fullheight">
					<div class="container py-5">

						{this.state.userData === undefined &&
							<div class="my-5 py-5 text-center"><div class="spinner-border"></div></div>
						}
						{this.state.userData === null &&
							<div class="text-center  my-5 p-5  max20 ">
								<div class="h3">🧐</div>
								<div class="text-muted text-uppercase small">Unknown User</div>
							</div>
						}

						{this.state.userData &&
							<div>

								<div class="h3 text-center my-3 ">
									<img class="profile-pic mr-2 rounded-circle" src={this.state.userData.photoURL} />
									{/* {this.state.userData.twitterUsername} */}
								</div>
								{true &&
									<div class="text-center h4 my-3 max20">
										{this.state.userData.titleText || this.state.userData.twitterUsername}
									</div>
								}



								{!this.state.followerId &&
									<>
										{this.state.userData.descriptionText &&
											<div class="text-center text-muted my-3 max20">
												{this.state.userData.descriptionText}
											</div>
										}

										<form onSubmit={this.handleSubmit} class="my-4  max20">

											<div class="input-group mb-3">
												<input type="email" class="form-control border-dark" id="email" placeholder="Email" ref={this.email} />
												<div class="input-group-append">
													<button type="submit" class="btn btn-dark">Sign up</button>
												</div>
											</div>

										</form>
									</>
								}

								{this.state.followerId &&
									<div class="max30">
										<div class="text-center  my-4 p-4 bg-light rounded">
											<div class="h3">👍</div>
											<div class="h6 text-muted m-0">You're on the list</div>
										</div>

										<div class="h6 ">Refer others to get rewards</div>
										<div class="text-muted">{this.state.userData.referralText || "Share this link with others and you'll get credit for anyone who signs up from it."}</div>


										<form onSubmit={this.handleSubmitReferralExtra} class="my-4  ">
											<div class="form-group">
												{/* <label htmlFor="referralDisplayName" class="small text-uppercase text-muted mb-0">Leaderboard Display Name</label> */}
												<input type="text" class="form-control form-control-sm" id="referralDisplayName" placeholder="Leaderboard Display Name" ref={this.referralDisplayName} defaultValue={this.state.followerReferralDisplayName} />
											</div>
											{/* {this.state.userData.referralExtraInputTitle &&
												<div class="form-group">
													<input type="text" class="form-control form-control-sm" id="referralExtraInputValue" placeholder={this.state.userData.referralExtraInputTitle} ref={this.referralExtraInputValue} defaultValue={this.state.followerReferralExtraInputValue} />
												</div>
											} */}
											<div class=" my-">
												<button type="submit" class="btn btn-dark btn-sm btn-block text-capitalize">{'Generate Referral Link'}</button>
											</div>
										</form>

										{this.state.handleSubmitReferralExtraStatus == 'Saved!' &&
											<>
												<div class="text-muted mt-4 mb-1">Share this referral link</div>
												<div class="input-group mb-3">
													<input type="text" class="form-control form-control-sm border-dark" value={window.location.host + this.referralLink()} readOnly />
													<div class="input-group-append">
														<button type="button" class="btn btn-dark btn-sm" onClick={this.copyReferralLink}>{this.state.copyReferralLinkStatus || 'Copy'}</button>
													</div>
												</div>

												{/* <div class="overflow-auto">
													<Link to={this.referralLink()} target="_blank">{window.location.host + this.referralLink()}</Link>
												</div> */}
												<div class="text-center small font-weight-500 mt-4">
													<Link class=" mx-2" to={"/" + this.state.userData.twitterUsername + "/leaderboard"}>Show Referral Leaderboard</Link>
												</div>
											</>
										}



									</div>

								}
							</div>
						}


					</div>
				</div>
			</>
		)
	}


}

export default User
